import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";

export const getServices = () => {
  return queryOptions({
    queryKey: ["/api/services"],
    queryFn: async () => {
      return await handleClientMethod(client.GET("/api/services", {}));
    },
  });
};
